import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function Login() {
	const { login } = useAuth();
	const navigate = useNavigate();
	const [form, setForm] = useState({ email: "", password: "" });
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);
	
	const handleSubmit = async (e) => {
		e.preventDefault();
		setError("");
		setLoading(true);
		try {
			const result = await login(form.email, form.password);
			
			if (result.status === "mfaRequired") {
				// Pass mfaToken and firstName through navigation state
				navigate("/mfa-verify", {
					state: {
						mfaToken: result.mfaToken,
						firstName: result.firstName,
					},
				});
				return;
			}
			
			if (result.status === "totpSetupRequired") {
				navigate("/totp-setup");
				return;
			}
			
			navigate("/order");
		} catch (err) {
			setError(
				err.response?.data?.error || "Login failed. Please try again."
			);
		} finally {
			setLoading(false);
		}
	};
	
	return (
		<div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8
		border border-farm-tan/30 dark:border-gray-700
		transition-colors duration-200">
		<h2 className="text-2xl font-bold text-farm-green dark:text-green-400
		mb-6 text-center">
		Sign In to Your Account
		</h2>
		
		{error && (
			<div className="bg-red-50 dark:bg-red-900/30 border border-red-300
			dark:border-red-600 text-red-700 dark:text-red-300
			rounded-lg p-3 mb-4 text-sm">
			{error}
			</div>
		)}
		
		<form onSubmit={handleSubmit} className="space-y-4">
		<div>
		<label className="block text-sm font-medium text-gray-700
		dark:text-gray-300 mb-1">
		Email Address
		</label>
		<input
		type="email"
		required
		value={form.email}
		onChange={(e) => setForm({ ...form, email: e.target.value })}
		className="w-full border border-gray-300 dark:border-gray-600
		rounded-lg px-3 py-2 bg-white dark:bg-gray-700
		text-gray-800 dark:text-gray-100
		placeholder-gray-400 dark:placeholder-gray-500
		focus:outline-none focus:ring-2 focus:ring-farm-green"
		placeholder="you@example.com"
		/>
		</div>
		
		<div>
		<div className="flex items-center justify-between mb-1">
		<label className="block text-sm font-medium text-gray-700
		dark:text-gray-300">
		Password
		</label>
		<Link
		to="/forgot-password"
		className="text-xs text-farm-green dark:text-green-400
		hover:underline"
		>
		Forgot password?
		</Link>
		</div>
		<input
		type="password"
		required
		value={form.password}
		onChange={(e) =>
			setForm({ ...form, password: e.target.value })
		}
		className="w-full border border-gray-300 dark:border-gray-600
		rounded-lg px-3 py-2 bg-white dark:bg-gray-700
		text-gray-800 dark:text-gray-100
		placeholder-gray-400 dark:placeholder-gray-500
		focus:outline-none focus:ring-2 focus:ring-farm-green"
		placeholder="••••••••"
		/>
		</div>
		
		<button
		type="submit"
		disabled={loading}
		className="w-full bg-farm-green text-white py-3 rounded-xl
		font-semibold hover:bg-green-700 transition-colors
		disabled:opacity-60"
		>
		{loading ? "Signing In…" : "Sign In"}
		</button>
		</form>
		
		<p className="mt-4 text-center text-sm text-gray-600 dark:text-gray-400">
		Don't have an account?{" "}
		<Link
		to="/register"
		className="text-farm-green dark:text-green-400 font-semibold
		hover:underline"
		>
		Create one
		</Link>
		</p>
		</div>
	);
}
